var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":function($event){return _vm.exportFile()}}},[_vm._v(" Exportera ")])
}
var staticRenderFns = []

export { render, staticRenderFns }